import { campaignImage } from './shared';
import {
  Glow,
  Hero,
  HeroBg,
  HeroCopy,
  HeroLead,
  HeroProduct,
  HeroProductImg,
  HeroTitle,
  Star,
  StarCluster
} from './pollScreenStyles';

const PollHero = () => (
  <Hero>
    <HeroBg src={campaignImage('poll-bg.png')} alt="" />
    <Glow $side="left" src={campaignImage('glow-left.svg')} alt="" />
    <Glow $side="right" src={campaignImage('glow-right.svg')} alt="" />
    <HeroProduct $side="left">
      <HeroProductImg
        $side="left"
        src={campaignImage('poll-laptop.png')}
        alt=""
      />
    </HeroProduct>
    <HeroProduct $side="right">
      <HeroProductImg
        $side="right"
        src={campaignImage('poll-ps5.png')}
        alt=""
      />
    </HeroProduct>
    <Star src={campaignImage('star.svg')} $top="12%" $left="5%" $size={27} />
    <Star src={campaignImage('star.svg')} $top="22%" $left="2%" $size={21} />
    <Star src={campaignImage('star.svg')} $top="24%" $left="20%" $size={22} />
    <Star src={campaignImage('star.svg')} $top="40%" $left="23.5%" $size={9} />
    <Star src={campaignImage('star.svg')} $top="19%" $right="8%" $size={22} />
    <Star src={campaignImage('star.svg')} $top="15%" $right="17%" $size={16} />
    <Star src={campaignImage('star.svg')} $top="13%" $right="2.5%" $size={15} />
    <Star src={campaignImage('star.svg')} $top="20%" $right="0.8%" $size={22} />
    <StarCluster $side="left" src={campaignImage('stars-left.svg')} alt="" />
    <StarCluster $side="right" src={campaignImage('stars-right.svg')} alt="" />
    <HeroCopy>
      <HeroLead>Honest jawab do.</HeroLead>
      <HeroLead $mobile>For what will you</HeroLead>
      <div>
        <HeroTitle>iPad padhai ke liye?</HeroTitle>
        <HeroTitle>Ya PS5 ka bahana? 😏</HeroTitle>
      </div>
    </HeroCopy>
  </Hero>
);

export default PollHero;
